// extracted by mini-css-extract-plugin
export default {"Circle":"Circle_Circle__h0LD3"};